var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.queries),function(query){return _c('b-list-group-item',{key:query.id},[_c('FormQueriesListItem',{attrs:{"query":query},on:{"view":_vm.viewQuery}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }